//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';


//-================ IMPORTS FOR CONSTANTS ================-\\


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Filter_Check_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Filter_Check_CCP.interface';
import { TASK_ALL_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/All-Task-CCP.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';


@Component({
    selector: 'app-see-all-tasks-lib-ccp',
    templateUrl: './see-all-tasks-lib-ccp.component.html',
    styleUrls: ['./see-all-tasks-lib-ccp.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/LibrayGlobal.css', '../../../../../Styles/TasksGlobal.css'],
    standalone: false
})
export class SeeAllTasksLibCCPComponent implements OnInit {

  //-========================= SECTION VARIABLES =========================-\\
  //+================== ARRAYS ==================+\\
  public List_All_Task: TASK_ALL_CCP[] = [];
  public SelectedList_All_Task: TASK_ALL_CCP[] = [];

  //+================== VARIABLES CREDENTIALS ==================+\\
  private ID_User_DB: number = 0;

  //+================== SEARCH ==================+\\
  public Task_Filter: string = '';

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';

  //+================== VARIABLES FOR MODULE PAGINATION ==================+\\
  public NumberPage: number = 1; // variable to number page in ngx - pagination
  public ItemfoPage: number = 5; // variable for item per page

  public LoadPage: boolean = false;

  //+================== VARIABLES FOR HEADERS TASK ==================+\\
  public HeadersTask: Headers_CCP[] = [
    { ID: 1, Name: 'Nombre de tarea', Position: 1, Visible: true, Key_Header: 'NAT' },
    { ID: 1, Name: 'Folio 4M', Position: 1, Visible: true, Key_Header: 'INV' },
    { ID: 1, Name: 'asignación', Position: 1, Visible: true, Key_Header: 'DAA' },
    { ID: 1, Name: 'Usuario que asigno', Position: 1, Visible: true, Key_Header: 'USA' },
    { ID: 1, Name: 'Descripción', Position: 1, Visible: true, Key_Header: 'DES' },
  ];

  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: Filter_Check_CCP = {
    Extension: [],
    Model_Year: [],
    Status: [],
    Reviewer_Name: [],
    Approver_Name: [],
    Contributor_Name: [],
  };


  constructor(private Service_CCP: LIBRARYCCPService) {
    this.ID_User_DB = Number(localStorage.getItem('ID_U_DB'));
  }

  ngOnInit(): void {

    this.Load_Component_Task();

  }


  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async Load_Component_Task(): Promise<void> {

    this.LoadPage = false;

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    const ResGetTasks: any = await firstValueFrom(this.Service_CCP.GetTaskOfUser({ ID_Involved_User: this.ID_User_DB, Status: 1, IsConsultViewTask: true }));


    if (ResGetTasks.success) {
      this.LoadPage = true;
      const All_Task = ResGetTasks.operation;

      const TemTask: TASK_ALL_CCP[] = [];

      for (const Task of All_Task) {
        TemTask.push({
          ID: Task.ID,
          ID_WF: Task.ID_WF,
          ID_Involved_User: Task.ID_Involved_User,
          Status: Task.Status,
          Date_Start: Task.Date_Start,
          Name: Task.Name,
          NameUser: Task.NameUser,
          Invoice_4M: Task.Invoice_4M
        })
      }

      this.List_All_Task = TemTask;

      Loader.classList.remove('active');

      this.Generate_Filters();

    } else {
      this.LoadPage = true;
      Loader.classList.remove('active');

      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\



  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION FOR FORMAT DATE CREATED ==================-\\
  public DateTaskCreate(Date_Start: Date): string {
    return moment(Date_Start).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-================== FUNCTTION FOR GREEATING ==================-\\
  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }

  //-================== FUNCTION FOR FILTERS ==================-\\

  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Extension: [],
      Model_Year: [],
      Status: [],
      Reviewer_Name: [],
      Approver_Name: [],
      Contributor_Name: [],
    };

    for (const CCP of this.List_All_Task) {

      CCP.Date_Start = moment(CCP.Date_Start).utc().toDate();

      if (!this.Filter_Global_Check.Contributor_Name.includes(CCP.NameUser) && CCP.NameUser !== null) {
        this.Filter_Global_Check.Contributor_Name.push(CCP.NameUser);
      }

    }


  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\
}
